/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletPaymentRouteImport } from './routes/wallet-payment'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as UnlockedContentRouteImport } from './routes/unlocked-content'
import { Route as ShareProfileRouteImport } from './routes/share-profile'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ReelsRouteImport } from './routes/reels'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PinManagementRouteImport } from './routes/pin-management'
import { Route as OtpRouteImport } from './routes/otp'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as NewChatRouteImport } from './routes/new-chat'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LivePreConfigureRouteImport } from './routes/live-pre-configure'
import { Route as LiveBroadcastRouteImport } from './routes/live-broadcast'
import { Route as LiveRouteImport } from './routes/live'
import { Route as HelpRouteImport } from './routes/help'
import { Route as GamesSlotsRouteImport } from './routes/games-slots'
import { Route as GamesDartsRouteImport } from './routes/games-darts'
import { Route as GamesBlackjackRouteImport } from './routes/games-blackjack'
import { Route as GamesRouteImport } from './routes/games'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as EditProfileRouteImport } from './routes/edit-profile'
import { Route as CreateReelRouteImport } from './routes/create-reel'
import { Route as CreateRouteImport } from './routes/create'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as BiometricSetupRouteImport } from './routes/biometric-setup'
import { Route as AdminLiteRouteImport } from './routes/admin-lite'
import { Route as ActiveDevicesRouteImport } from './routes/active-devices'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as LiveViewStreamIdRouteImport } from './routes/live-view.$streamId'
import { Route as ChatChatIdRouteImport } from './routes/chat.$chatId'

const KycOnboardingLazyRouteImport = createFileRoute('/kyc-onboarding')()

const KycOnboardingLazyRoute = KycOnboardingLazyRouteImport.update({
  id: '/kyc-onboarding',
  path: '/kyc-onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/kyc-onboarding.lazy').then((d) => d.Route),
)
const WalletPaymentRoute = WalletPaymentRouteImport.update({
  id: '/wallet-payment',
  path: '/wallet-payment',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/wallet-payment.lazy').then((d) => d.Route),
)
const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/wallet.lazy').then((d) => d.Route))
const UnlockedContentRoute = UnlockedContentRouteImport.update({
  id: '/unlocked-content',
  path: '/unlocked-content',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/unlocked-content.lazy').then((d) => d.Route),
)
const ShareProfileRoute = ShareProfileRouteImport.update({
  id: '/share-profile',
  path: '/share-profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/share-profile.lazy').then((d) => d.Route))
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/search.lazy').then((d) => d.Route))
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/register.lazy').then((d) => d.Route))
const ReelsRoute = ReelsRouteImport.update({
  id: '/reels',
  path: '/reels',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/reels.lazy').then((d) => d.Route))
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const PinManagementRoute = PinManagementRouteImport.update({
  id: '/pin-management',
  path: '/pin-management',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/pin-management.lazy').then((d) => d.Route),
)
const OtpRoute = OtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/otp.lazy').then((d) => d.Route))
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/onboarding.lazy').then((d) => d.Route))
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/notifications.lazy').then((d) => d.Route))
const NewChatRoute = NewChatRouteImport.update({
  id: '/new-chat',
  path: '/new-chat',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/new-chat.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const LivePreConfigureRoute = LivePreConfigureRouteImport.update({
  id: '/live-pre-configure',
  path: '/live-pre-configure',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/live-pre-configure.lazy').then((d) => d.Route),
)
const LiveBroadcastRoute = LiveBroadcastRouteImport.update({
  id: '/live-broadcast',
  path: '/live-broadcast',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/live-broadcast.lazy').then((d) => d.Route),
)
const LiveRoute = LiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/live.lazy').then((d) => d.Route))
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/help.lazy').then((d) => d.Route))
const GamesSlotsRoute = GamesSlotsRouteImport.update({
  id: '/games-slots',
  path: '/games-slots',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/games-slots.lazy').then((d) => d.Route))
const GamesDartsRoute = GamesDartsRouteImport.update({
  id: '/games-darts',
  path: '/games-darts',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/games-darts.lazy').then((d) => d.Route))
const GamesBlackjackRoute = GamesBlackjackRouteImport.update({
  id: '/games-blackjack',
  path: '/games-blackjack',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/games-blackjack.lazy').then((d) => d.Route),
)
const GamesRoute = GamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/games.lazy').then((d) => d.Route))
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/feed.lazy').then((d) => d.Route))
const EditProfileRoute = EditProfileRouteImport.update({
  id: '/edit-profile',
  path: '/edit-profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/edit-profile.lazy').then((d) => d.Route))
const CreateReelRoute = CreateReelRouteImport.update({
  id: '/create-reel',
  path: '/create-reel',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/create-reel.lazy').then((d) => d.Route))
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/create.lazy').then((d) => d.Route))
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/chat.lazy').then((d) => d.Route))
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/change-password.lazy').then((d) => d.Route),
)
const BiometricSetupRoute = BiometricSetupRouteImport.update({
  id: '/biometric-setup',
  path: '/biometric-setup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/biometric-setup.lazy').then((d) => d.Route),
)
const AdminLiteRoute = AdminLiteRouteImport.update({
  id: '/admin-lite',
  path: '/admin-lite',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin-lite.lazy').then((d) => d.Route))
const ActiveDevicesRoute = ActiveDevicesRouteImport.update({
  id: '/active-devices',
  path: '/active-devices',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/active-devices.lazy').then((d) => d.Route),
)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/users.$userId.lazy').then((d) => d.Route))
const LiveViewStreamIdRoute = LiveViewStreamIdRouteImport.update({
  id: '/live-view/$streamId',
  path: '/live-view/$streamId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/live-view.$streamId.lazy').then((d) => d.Route),
)
const ChatChatIdRoute = ChatChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => ChatRoute,
} as any).lazy(() => import('./routes/chat.$chatId.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/active-devices': typeof ActiveDevicesRoute
  '/admin-lite': typeof AdminLiteRoute
  '/biometric-setup': typeof BiometricSetupRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRouteWithChildren
  '/create': typeof CreateRoute
  '/create-reel': typeof CreateReelRoute
  '/edit-profile': typeof EditProfileRoute
  '/feed': typeof FeedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/games': typeof GamesRoute
  '/games-blackjack': typeof GamesBlackjackRoute
  '/games-darts': typeof GamesDartsRoute
  '/games-slots': typeof GamesSlotsRoute
  '/help': typeof HelpRoute
  '/live': typeof LiveRoute
  '/live-broadcast': typeof LiveBroadcastRoute
  '/live-pre-configure': typeof LivePreConfigureRoute
  '/login': typeof LoginRoute
  '/new-chat': typeof NewChatRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/otp': typeof OtpRoute
  '/pin-management': typeof PinManagementRoute
  '/profile': typeof ProfileRoute
  '/reels': typeof ReelsRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/share-profile': typeof ShareProfileRoute
  '/unlocked-content': typeof UnlockedContentRoute
  '/wallet': typeof WalletRoute
  '/wallet-payment': typeof WalletPaymentRoute
  '/kyc-onboarding': typeof KycOnboardingLazyRoute
  '/chat/$chatId': typeof ChatChatIdRoute
  '/live-view/$streamId': typeof LiveViewStreamIdRoute
  '/users/$userId': typeof UsersUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/active-devices': typeof ActiveDevicesRoute
  '/admin-lite': typeof AdminLiteRoute
  '/biometric-setup': typeof BiometricSetupRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRouteWithChildren
  '/create': typeof CreateRoute
  '/create-reel': typeof CreateReelRoute
  '/edit-profile': typeof EditProfileRoute
  '/feed': typeof FeedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/games': typeof GamesRoute
  '/games-blackjack': typeof GamesBlackjackRoute
  '/games-darts': typeof GamesDartsRoute
  '/games-slots': typeof GamesSlotsRoute
  '/help': typeof HelpRoute
  '/live': typeof LiveRoute
  '/live-broadcast': typeof LiveBroadcastRoute
  '/live-pre-configure': typeof LivePreConfigureRoute
  '/login': typeof LoginRoute
  '/new-chat': typeof NewChatRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/otp': typeof OtpRoute
  '/pin-management': typeof PinManagementRoute
  '/profile': typeof ProfileRoute
  '/reels': typeof ReelsRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/share-profile': typeof ShareProfileRoute
  '/unlocked-content': typeof UnlockedContentRoute
  '/wallet': typeof WalletRoute
  '/wallet-payment': typeof WalletPaymentRoute
  '/kyc-onboarding': typeof KycOnboardingLazyRoute
  '/chat/$chatId': typeof ChatChatIdRoute
  '/live-view/$streamId': typeof LiveViewStreamIdRoute
  '/users/$userId': typeof UsersUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/active-devices': typeof ActiveDevicesRoute
  '/admin-lite': typeof AdminLiteRoute
  '/biometric-setup': typeof BiometricSetupRoute
  '/change-password': typeof ChangePasswordRoute
  '/chat': typeof ChatRouteWithChildren
  '/create': typeof CreateRoute
  '/create-reel': typeof CreateReelRoute
  '/edit-profile': typeof EditProfileRoute
  '/feed': typeof FeedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/games': typeof GamesRoute
  '/games-blackjack': typeof GamesBlackjackRoute
  '/games-darts': typeof GamesDartsRoute
  '/games-slots': typeof GamesSlotsRoute
  '/help': typeof HelpRoute
  '/live': typeof LiveRoute
  '/live-broadcast': typeof LiveBroadcastRoute
  '/live-pre-configure': typeof LivePreConfigureRoute
  '/login': typeof LoginRoute
  '/new-chat': typeof NewChatRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/otp': typeof OtpRoute
  '/pin-management': typeof PinManagementRoute
  '/profile': typeof ProfileRoute
  '/reels': typeof ReelsRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/share-profile': typeof ShareProfileRoute
  '/unlocked-content': typeof UnlockedContentRoute
  '/wallet': typeof WalletRoute
  '/wallet-payment': typeof WalletPaymentRoute
  '/kyc-onboarding': typeof KycOnboardingLazyRoute
  '/chat/$chatId': typeof ChatChatIdRoute
  '/live-view/$streamId': typeof LiveViewStreamIdRoute
  '/users/$userId': typeof UsersUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/active-devices'
    | '/admin-lite'
    | '/biometric-setup'
    | '/change-password'
    | '/chat'
    | '/create'
    | '/create-reel'
    | '/edit-profile'
    | '/feed'
    | '/forgot-password'
    | '/games'
    | '/games-blackjack'
    | '/games-darts'
    | '/games-slots'
    | '/help'
    | '/live'
    | '/live-broadcast'
    | '/live-pre-configure'
    | '/login'
    | '/new-chat'
    | '/notifications'
    | '/onboarding'
    | '/otp'
    | '/pin-management'
    | '/profile'
    | '/reels'
    | '/register'
    | '/search'
    | '/settings'
    | '/share-profile'
    | '/unlocked-content'
    | '/wallet'
    | '/wallet-payment'
    | '/kyc-onboarding'
    | '/chat/$chatId'
    | '/live-view/$streamId'
    | '/users/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/active-devices'
    | '/admin-lite'
    | '/biometric-setup'
    | '/change-password'
    | '/chat'
    | '/create'
    | '/create-reel'
    | '/edit-profile'
    | '/feed'
    | '/forgot-password'
    | '/games'
    | '/games-blackjack'
    | '/games-darts'
    | '/games-slots'
    | '/help'
    | '/live'
    | '/live-broadcast'
    | '/live-pre-configure'
    | '/login'
    | '/new-chat'
    | '/notifications'
    | '/onboarding'
    | '/otp'
    | '/pin-management'
    | '/profile'
    | '/reels'
    | '/register'
    | '/search'
    | '/settings'
    | '/share-profile'
    | '/unlocked-content'
    | '/wallet'
    | '/wallet-payment'
    | '/kyc-onboarding'
    | '/chat/$chatId'
    | '/live-view/$streamId'
    | '/users/$userId'
  id:
    | '__root__'
    | '/'
    | '/active-devices'
    | '/admin-lite'
    | '/biometric-setup'
    | '/change-password'
    | '/chat'
    | '/create'
    | '/create-reel'
    | '/edit-profile'
    | '/feed'
    | '/forgot-password'
    | '/games'
    | '/games-blackjack'
    | '/games-darts'
    | '/games-slots'
    | '/help'
    | '/live'
    | '/live-broadcast'
    | '/live-pre-configure'
    | '/login'
    | '/new-chat'
    | '/notifications'
    | '/onboarding'
    | '/otp'
    | '/pin-management'
    | '/profile'
    | '/reels'
    | '/register'
    | '/search'
    | '/settings'
    | '/share-profile'
    | '/unlocked-content'
    | '/wallet'
    | '/wallet-payment'
    | '/kyc-onboarding'
    | '/chat/$chatId'
    | '/live-view/$streamId'
    | '/users/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActiveDevicesRoute: typeof ActiveDevicesRoute
  AdminLiteRoute: typeof AdminLiteRoute
  BiometricSetupRoute: typeof BiometricSetupRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ChatRoute: typeof ChatRouteWithChildren
  CreateRoute: typeof CreateRoute
  CreateReelRoute: typeof CreateReelRoute
  EditProfileRoute: typeof EditProfileRoute
  FeedRoute: typeof FeedRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GamesRoute: typeof GamesRoute
  GamesBlackjackRoute: typeof GamesBlackjackRoute
  GamesDartsRoute: typeof GamesDartsRoute
  GamesSlotsRoute: typeof GamesSlotsRoute
  HelpRoute: typeof HelpRoute
  LiveRoute: typeof LiveRoute
  LiveBroadcastRoute: typeof LiveBroadcastRoute
  LivePreConfigureRoute: typeof LivePreConfigureRoute
  LoginRoute: typeof LoginRoute
  NewChatRoute: typeof NewChatRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  OtpRoute: typeof OtpRoute
  PinManagementRoute: typeof PinManagementRoute
  ProfileRoute: typeof ProfileRoute
  ReelsRoute: typeof ReelsRoute
  RegisterRoute: typeof RegisterRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  ShareProfileRoute: typeof ShareProfileRoute
  UnlockedContentRoute: typeof UnlockedContentRoute
  WalletRoute: typeof WalletRoute
  WalletPaymentRoute: typeof WalletPaymentRoute
  KycOnboardingLazyRoute: typeof KycOnboardingLazyRoute
  LiveViewStreamIdRoute: typeof LiveViewStreamIdRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/kyc-onboarding': {
      id: '/kyc-onboarding'
      path: '/kyc-onboarding'
      fullPath: '/kyc-onboarding'
      preLoaderRoute: typeof KycOnboardingLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallet-payment': {
      id: '/wallet-payment'
      path: '/wallet-payment'
      fullPath: '/wallet-payment'
      preLoaderRoute: typeof WalletPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unlocked-content': {
      id: '/unlocked-content'
      path: '/unlocked-content'
      fullPath: '/unlocked-content'
      preLoaderRoute: typeof UnlockedContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share-profile': {
      id: '/share-profile'
      path: '/share-profile'
      fullPath: '/share-profile'
      preLoaderRoute: typeof ShareProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reels': {
      id: '/reels'
      path: '/reels'
      fullPath: '/reels'
      preLoaderRoute: typeof ReelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin-management': {
      id: '/pin-management'
      path: '/pin-management'
      fullPath: '/pin-management'
      preLoaderRoute: typeof PinManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp': {
      id: '/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof OtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-chat': {
      id: '/new-chat'
      path: '/new-chat'
      fullPath: '/new-chat'
      preLoaderRoute: typeof NewChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-pre-configure': {
      id: '/live-pre-configure'
      path: '/live-pre-configure'
      fullPath: '/live-pre-configure'
      preLoaderRoute: typeof LivePreConfigureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-broadcast': {
      id: '/live-broadcast'
      path: '/live-broadcast'
      fullPath: '/live-broadcast'
      preLoaderRoute: typeof LiveBroadcastRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live': {
      id: '/live'
      path: '/live'
      fullPath: '/live'
      preLoaderRoute: typeof LiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games-slots': {
      id: '/games-slots'
      path: '/games-slots'
      fullPath: '/games-slots'
      preLoaderRoute: typeof GamesSlotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games-darts': {
      id: '/games-darts'
      path: '/games-darts'
      fullPath: '/games-darts'
      preLoaderRoute: typeof GamesDartsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games-blackjack': {
      id: '/games-blackjack'
      path: '/games-blackjack'
      fullPath: '/games-blackjack'
      preLoaderRoute: typeof GamesBlackjackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games': {
      id: '/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit-profile': {
      id: '/edit-profile'
      path: '/edit-profile'
      fullPath: '/edit-profile'
      preLoaderRoute: typeof EditProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-reel': {
      id: '/create-reel'
      path: '/create-reel'
      fullPath: '/create-reel'
      preLoaderRoute: typeof CreateReelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/biometric-setup': {
      id: '/biometric-setup'
      path: '/biometric-setup'
      fullPath: '/biometric-setup'
      preLoaderRoute: typeof BiometricSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-lite': {
      id: '/admin-lite'
      path: '/admin-lite'
      fullPath: '/admin-lite'
      preLoaderRoute: typeof AdminLiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/active-devices': {
      id: '/active-devices'
      path: '/active-devices'
      fullPath: '/active-devices'
      preLoaderRoute: typeof ActiveDevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-view/$streamId': {
      id: '/live-view/$streamId'
      path: '/live-view/$streamId'
      fullPath: '/live-view/$streamId'
      preLoaderRoute: typeof LiveViewStreamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$chatId': {
      id: '/chat/$chatId'
      path: '/$chatId'
      fullPath: '/chat/$chatId'
      preLoaderRoute: typeof ChatChatIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatChatIdRoute: typeof ChatChatIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatChatIdRoute: ChatChatIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActiveDevicesRoute: ActiveDevicesRoute,
  AdminLiteRoute: AdminLiteRoute,
  BiometricSetupRoute: BiometricSetupRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ChatRoute: ChatRouteWithChildren,
  CreateRoute: CreateRoute,
  CreateReelRoute: CreateReelRoute,
  EditProfileRoute: EditProfileRoute,
  FeedRoute: FeedRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GamesRoute: GamesRoute,
  GamesBlackjackRoute: GamesBlackjackRoute,
  GamesDartsRoute: GamesDartsRoute,
  GamesSlotsRoute: GamesSlotsRoute,
  HelpRoute: HelpRoute,
  LiveRoute: LiveRoute,
  LiveBroadcastRoute: LiveBroadcastRoute,
  LivePreConfigureRoute: LivePreConfigureRoute,
  LoginRoute: LoginRoute,
  NewChatRoute: NewChatRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  OtpRoute: OtpRoute,
  PinManagementRoute: PinManagementRoute,
  ProfileRoute: ProfileRoute,
  ReelsRoute: ReelsRoute,
  RegisterRoute: RegisterRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  ShareProfileRoute: ShareProfileRoute,
  UnlockedContentRoute: UnlockedContentRoute,
  WalletRoute: WalletRoute,
  WalletPaymentRoute: WalletPaymentRoute,
  KycOnboardingLazyRoute: KycOnboardingLazyRoute,
  LiveViewStreamIdRoute: LiveViewStreamIdRoute,
  UsersUserIdRoute: UsersUserIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
